export class CashMovementReconciliationRecordDto {
  id: number;
  valueDate: Date;
  displayName: string;
  accountId: number;
  currencyCode: string;
  sumTradeMatured: number;
  sumExchangeFee: number;
  totalAmount: number;
  carriedForward: number | undefined;
  netAmount: number;
  settlement: number;
  match: boolean;
  diff: number;
  FBClearing: boolean;
  FBClient: boolean;
  ABOSPost: boolean;
  ABOSReview: boolean;
  netDiff: boolean;
  notes: string;
  colorId: number;
  source: string;
}
